import React, { useRef } from 'react';

interface AssetUsageOverviewVideoProps {
  videoUrl?: string;
}

const AssetUsageOverviewVideo: React.FC<AssetUsageOverviewVideoProps> = ({ videoUrl }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div style={{ position: 'relative', width: '100%', borderRadius: 12, overflow: 'hidden' }}>
      <video
        ref={videoRef}
        controls
        controlsList="nodownload"
        autoPlay
        muted
        loop
        style={{ width: '100%', borderRadius: 12, display: 'block' }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
export default AssetUsageOverviewVideo;
